import {
  Banknote,
  BookOpen,
  Box,
  BriefcaseBusiness,
  Building2,
  CalendarDays,
  Camera,
  ChartColumn,
  ChartColumnBig,
  Clock3,
  Cloud,
  Code2,
  Contact,
  CreditCard,
  Database,
  DollarSign,
  FileText,
  Flag,
  Folder,
  Gift,
  Globe,
  Handshake,
  Headphones,
  Heart,
  Image,
  Kanban,
  KeyRound,
  Lightbulb,
  Link2,
  ListChecks,
  Lock,
  Mail,
  Map,
  MessageSquare,
  Music4,
  NotebookPen,
  Package,
  Phone,
  PieChart,
  Pin,
  ReceiptText,
  Rocket,
  Server,
  Settings,
  Shield,
  ShoppingCart,
  Star,
  Store,
  Tag,
  Target,
  TrendingUp,
  Trophy,
  Truck,
  User,
  Users,
  Video,
  WalletCards,
  Warehouse,
  Wrench,
  Zap,
} from 'lucide-react'
import type { LucideIcon } from 'lucide-react'
import type { TFunction } from 'i18next'
import type { DocumentCollectionIcon } from '@/graphql/schema'
import { ICON_VALUE_TO_I18N_KEY } from '@/entities/document-collection/document-collection-icon-labels'

export type DocumentCollectionIconOption = {
  value: DocumentCollectionIcon
  label: string
  Icon: LucideIcon
}

export const documentCollectionIconOptions: Array<DocumentCollectionIconOption> =
  [
    { value: 'BOOK' as DocumentCollectionIcon, label: 'Book', Icon: BookOpen },
    {
      value: 'FOLDER' as DocumentCollectionIcon,
      label: 'Folder',
      Icon: Folder,
    },
    { value: 'FILE' as DocumentCollectionIcon, label: 'File', Icon: FileText },
    {
      value: 'NOTE' as DocumentCollectionIcon,
      label: 'Note',
      Icon: NotebookPen,
    },
    { value: 'STAR' as DocumentCollectionIcon, label: 'Star', Icon: Star },
    { value: 'HEART' as DocumentCollectionIcon, label: 'Heart', Icon: Heart },
    { value: 'TAG' as DocumentCollectionIcon, label: 'Tag', Icon: Tag },
    { value: 'PIN' as DocumentCollectionIcon, label: 'Pin', Icon: Pin },
    { value: 'FLAG' as DocumentCollectionIcon, label: 'Flag', Icon: Flag },
    {
      value: 'CALENDAR' as DocumentCollectionIcon,
      label: 'Calendar',
      Icon: CalendarDays,
    },
    { value: 'CLOCK' as DocumentCollectionIcon, label: 'Clock', Icon: Clock3 },
    {
      value: 'CHART' as DocumentCollectionIcon,
      label: 'Chart',
      Icon: ChartColumn,
    },
    {
      value: 'BAR_CHART' as DocumentCollectionIcon,
      label: 'Bar chart',
      Icon: ChartColumnBig,
    },
    {
      value: 'PIE_CHART' as DocumentCollectionIcon,
      label: 'Pie chart',
      Icon: PieChart,
    },
    {
      value: 'TREND_UP' as DocumentCollectionIcon,
      label: 'Trend',
      Icon: TrendingUp,
    },
    {
      value: 'CAMERA' as DocumentCollectionIcon,
      label: 'Camera',
      Icon: Camera,
    },
    { value: 'IMAGE' as DocumentCollectionIcon, label: 'Image', Icon: Image },
    { value: 'MUSIC' as DocumentCollectionIcon, label: 'Music', Icon: Music4 },
    { value: 'VIDEO' as DocumentCollectionIcon, label: 'Video', Icon: Video },
    { value: 'LINK' as DocumentCollectionIcon, label: 'Link', Icon: Link2 },
    { value: 'GLOBE' as DocumentCollectionIcon, label: 'Globe', Icon: Globe },
    { value: 'MAP' as DocumentCollectionIcon, label: 'Map', Icon: Map },
    {
      value: 'CART' as DocumentCollectionIcon,
      label: 'Cart',
      Icon: ShoppingCart,
    },
    { value: 'GIFT' as DocumentCollectionIcon, label: 'Gift', Icon: Gift },
    {
      value: 'BRIEFCASE' as DocumentCollectionIcon,
      label: 'Briefcase',
      Icon: BriefcaseBusiness,
    },
    {
      value: 'LIGHTBULB' as DocumentCollectionIcon,
      label: 'Idea',
      Icon: Lightbulb,
    },
    {
      value: 'ROCKET' as DocumentCollectionIcon,
      label: 'Rocket',
      Icon: Rocket,
    },
    { value: 'USERS' as DocumentCollectionIcon, label: 'Users', Icon: Users },
    { value: 'USER' as DocumentCollectionIcon, label: 'User', Icon: User },
    {
      value: 'BUILDING' as DocumentCollectionIcon,
      label: 'Building',
      Icon: Building2,
    },
    {
      value: 'CONTACT' as DocumentCollectionIcon,
      label: 'Contact',
      Icon: Contact,
    },
    {
      value: 'HANDSHAKE' as DocumentCollectionIcon,
      label: 'Handshake',
      Icon: Handshake,
    },
    {
      value: 'KANBAN' as DocumentCollectionIcon,
      label: 'Kanban',
      Icon: Kanban,
    },
    {
      value: 'LIST_CHECKS' as DocumentCollectionIcon,
      label: 'Checklist',
      Icon: ListChecks,
    },
    {
      value: 'PACKAGE' as DocumentCollectionIcon,
      label: 'Package',
      Icon: Package,
    },
    { value: 'BOX' as DocumentCollectionIcon, label: 'Box', Icon: Box },
    {
      value: 'RECEIPT' as DocumentCollectionIcon,
      label: 'Receipt',
      Icon: ReceiptText,
    },
    {
      value: 'WALLET' as DocumentCollectionIcon,
      label: 'Wallet',
      Icon: WalletCards,
    },
    {
      value: 'BANKNOTE' as DocumentCollectionIcon,
      label: 'Banknote',
      Icon: Banknote,
    },
    {
      value: 'CREDIT_CARD' as DocumentCollectionIcon,
      label: 'Credit card',
      Icon: CreditCard,
    },
    {
      value: 'DOLLAR_SIGN' as DocumentCollectionIcon,
      label: 'Dollar',
      Icon: DollarSign,
    },
    { value: 'STORE' as DocumentCollectionIcon, label: 'Store', Icon: Store },
    {
      value: 'WAREHOUSE' as DocumentCollectionIcon,
      label: 'Warehouse',
      Icon: Warehouse,
    },
    { value: 'TRUCK' as DocumentCollectionIcon, label: 'Truck', Icon: Truck },
    {
      value: 'WRENCH' as DocumentCollectionIcon,
      label: 'Wrench',
      Icon: Wrench,
    },
    {
      value: 'SETTINGS' as DocumentCollectionIcon,
      label: 'Settings',
      Icon: Settings,
    },
    {
      value: 'SHIELD' as DocumentCollectionIcon,
      label: 'Shield',
      Icon: Shield,
    },
    { value: 'LOCK' as DocumentCollectionIcon, label: 'Lock', Icon: Lock },
    { value: 'KEY' as DocumentCollectionIcon, label: 'Key', Icon: KeyRound },
    { value: 'MAIL' as DocumentCollectionIcon, label: 'Mail', Icon: Mail },
    { value: 'PHONE' as DocumentCollectionIcon, label: 'Phone', Icon: Phone },
    {
      value: 'MESSAGE' as DocumentCollectionIcon,
      label: 'Message',
      Icon: MessageSquare,
    },
    {
      value: 'HEADPHONES' as DocumentCollectionIcon,
      label: 'Headphones',
      Icon: Headphones,
    },
    { value: 'CODE' as DocumentCollectionIcon, label: 'Code', Icon: Code2 },
    {
      value: 'DATABASE' as DocumentCollectionIcon,
      label: 'Database',
      Icon: Database,
    },
    {
      value: 'SERVER' as DocumentCollectionIcon,
      label: 'Server',
      Icon: Server,
    },
    { value: 'CLOUD' as DocumentCollectionIcon, label: 'Cloud', Icon: Cloud },
    { value: 'ZAP' as DocumentCollectionIcon, label: 'Zap', Icon: Zap },
    {
      value: 'TARGET' as DocumentCollectionIcon,
      label: 'Target',
      Icon: Target,
    },
    {
      value: 'TROPHY' as DocumentCollectionIcon,
      label: 'Trophy',
      Icon: Trophy,
    },
  ]

const fallbackDocumentCollectionIconOption = documentCollectionIconOptions[1]

export function getDocumentCollectionIconOption(
  icon: DocumentCollectionIcon | null | undefined,
) {
  return (
    documentCollectionIconOptions.find((option) => option.value === icon) ??
    fallbackDocumentCollectionIconOption
  )
}

export function getDocumentCollectionIconLabel(
  icon: DocumentCollectionIcon | null | undefined,
  t?: TFunction<'documentCollections'>,
) {
  const option = getDocumentCollectionIconOption(icon)
  const key = ICON_VALUE_TO_I18N_KEY[option.value]

  if (t && key) {
    return t(key)
  }

  return option.label
}

export function getDocumentCollectionIconComponent(
  icon: DocumentCollectionIcon | null | undefined,
) {
  return getDocumentCollectionIconOption(icon).Icon
}

export const defaultDocumentCollectionIcon =
  fallbackDocumentCollectionIconOption.value

export const documentCollectionIconGridColumns = 12
export const documentCollectionIconGridRows = 5
